module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Campaign_InformationTitle")))]), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_Name",
      "validate": _vm.$v.campaign,
      "modelPath": "name",
      "acc": "name"
    },
    on: {
      "input": _vm.$v.campaign.name.$touch
    },
    model: {
      value: (_vm.campaign.name),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "name", $$v)
      },
      expression: "campaign.name"
    }
  }), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Campaigns_Subject",
      "validate": _vm.$v.campaign,
      "modelPath": "subject",
      "acc": "subject"
    },
    on: {
      "input": [_vm.$v.campaign.subject.$touch, _vm.$v.campaign.subject.$touch]
    },
    model: {
      value: (_vm.campaign.subject),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "subject", $$v)
      },
      expression: "campaign.subject"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Campaign_WhoIsThisFromTitle")))]), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_FromName",
      "validate": _vm.$v.campaign,
      "modelPath": "fromName",
      "acc": "fromName"
    },
    on: {
      "input": _vm.$v.campaign.fromName.$touch
    },
    model: {
      value: (_vm.campaign.fromName),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "fromName", $$v)
      },
      expression: "campaign.fromName"
    }
  }), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_FromEmail",
      "validate": _vm.$v.campaign,
      "modelPath": "fromEmail",
      "acc": "fromEmail"
    },
    on: {
      "input": [_vm.$v.campaign.fromEmail.$touch, _vm.$v.campaign.fromEmail.$touch]
    },
    model: {
      value: (_vm.campaign.fromEmail),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "fromEmail", $$v)
      },
      expression: "campaign.fromEmail"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "view__infos"
  }, [_vm._v(_vm._s(_vm.L.localize("CAmpaign_WhoIsThisFromText")))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f72c0080!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/campaigns/form/CampaignInformation.vue
// module id = 768
// module chunks = 1